export default function CTAFinal() {
  return (
    <section className="relative py-24 overflow-hidden bg-black">
      {/* Background elegante */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/523401f0f333a264011f21e07589d36d.jpg"
          alt="Momento de Decisão"
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black/90"></div>
      </div>

      {/* Raios de luz sutis */}
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <div className="absolute top-0 left-1/4 w-1 h-full bg-gradient-to-b from-amber-400/20 via-amber-500/10 to-transparent"></div>
        <div className="absolute top-0 right-1/4 w-1 h-full bg-gradient-to-b from-amber-400/20 via-amber-500/10 to-transparent"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center relative z-10">
        {/* Título elegante */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          <span className="block mb-2">Sua Vida Muda</span>
          <span className="block bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 bg-clip-text text-transparent">
            Quando Você Decide
          </span>
        </h2>

        {/* Citação elegante */}
        <div className="max-w-4xl mx-auto mb-10 bg-gray-900/50 backdrop-blur-sm border border-amber-500/30 p-8 rounded-xl">
          <p className="text-xl md:text-2xl text-gray-200 italic leading-relaxed mb-4">
            "Não são suas condições que determinam seu destino. São suas decisões que moldam sua realidade."
          </p>
          <div className="flex items-center justify-center gap-3">
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent"></div>
            <p className="text-amber-400 font-semibold">Tony Robbins</p>
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent"></div>
          </div>
        </div>

        {/* Mensagem elegante */}
        <div className="max-w-3xl mx-auto mb-12 space-y-4">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
            Você não precisa de mais informação. Você precisa de ação.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed">
            Cada dia sem agir é um dia sem crescer. Cada momento de hesitação é uma oportunidade perdida.
          </p>
        </div>

        {/* CTAs elegantes */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="/planos"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-10 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
          >
            <span>Começar Agora</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a
            href="/quiz"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-amber-400 hover:border-amber-300 px-10 py-4 rounded-full font-semibold text-lg shadow-md hover:shadow-lg transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-questionnaire-line text-xl"></i>
            <span>Fazer Quiz Gratuito</span>
          </a>
        </div>

        {/* Garantia elegante */}
        <div className="max-w-2xl mx-auto bg-gray-900/50 backdrop-blur-sm border border-amber-500/30 p-8 rounded-xl shadow-lg">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <div className="text-left">
              <div className="text-xl font-bold text-amber-400">Garantia de Satisfação</div>
              <div className="text-sm text-gray-400">7 dias para testar sem risco</div>
            </div>
          </div>
          <p className="text-gray-300 leading-relaxed border-t border-gray-700 pt-4">
            Assumimos todo o risco. Você só precisa decidir.
          </p>
        </div>

        {/* Stats elegantes */}
        <div className="flex flex-wrap justify-center gap-8 mt-12 pt-12 border-t border-gray-800">
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent mb-1">3.247+</div>
            <div className="text-gray-400 text-sm">Vidas Transformadas</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent mb-1">98%</div>
            <div className="text-gray-400 text-sm">Taxa de Satisfação</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent mb-1">7 dias</div>
            <div className="text-gray-400 text-sm">Para Resultados</div>
          </div>
        </div>

        {/* Mensagem final elegante */}
        <div className="mt-12 space-y-3">
          <p className="text-2xl md:text-3xl font-bold text-white leading-tight">
            O momento é <span className="bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent">agora</span>.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed">
            A única pergunta é: você vai decidir?
          </p>
        </div>
      </div>
    </section>
  );
}
